import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IJurisdictionApplyParams, IJurisdictionDiffPopupData, IJurisdictionVariantDiff } from '@shared/model/project';
import { JurisdictionService } from '@app/project/service';

@Component({
  selector: 'app-jurisdiction-diff-popup',
  templateUrl: './jurisdiction-diff-popup.component.html',
  styleUrls: ['./jurisdiction-diff-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JurisdictionDiffPopupComponent {
  variants: IJurisdictionVariantDiff[] = [];
  jurisdictionName: string = '';
  // NOTE: "только текущий" применим, когда правки затрагивают ровно один вариант:
  // на экране основных данных выбранного варианта нет
  singleVariantId: number | null = null;
  // NOTE: вызов из формы налогов (F4) - только текущий вариант, кнопки "Обновить все" нет
  showApplyAll: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IJurisdictionDiffPopupData,
    private _dialogRef: MatDialogRef<JurisdictionDiffPopupComponent>,
    private _jurisdictionService: JurisdictionService,
  ) {
    const onlyVariantId = data.onlyVariantId;
    this.variants = (data.variants ?? []).filter(
      ({ id, changes_count }) => changes_count > 0 && (onlyVariantId === undefined || id === onlyVariantId),
    );
    // NOTE: на en - name_en, бэкенд отдает name только по-русски
    this.jurisdictionName = this._jurisdictionService.getCountryName(data.jurisdiction);
    this.singleVariantId = this.variants.length === 1 ? this.variants[0].id : null;
    this.showApplyAll = onlyVariantId === undefined;
  }

  applyAll(): void {
    this._dialogRef.close({ variants: 'all' } as IJurisdictionApplyParams);
  }

  applyCurrent(): void {
    if (this.singleVariantId === null) return;
    this._dialogRef.close({ variants: 'current', variant_id: this.singleVariantId } as IJurisdictionApplyParams);
  }
}
